/**
 * Service to handle PDF document operations
 */
class ClientPdfDocumentService {
    private static instance: ClientPdfDocumentService;

    private constructor() {}

    public static getInstance(): ClientPdfDocumentService {
        if (!ClientPdfDocumentService.instance) {
            ClientPdfDocumentService.instance = new ClientPdfDocumentService();
        }
        return ClientPdfDocumentService.instance;
    }

    /**
     * Count the number of pages in a PDF file
     * @param pdfData - PDF file data as Uint8Array
     * @returns Promise with the number of pages
     */
    public async getPageCount(pdfData: Uint8Array): Promise<number> {
        try {
            const pdfLib = await import('pdf-lib');
            const pdfDoc = await pdfLib.PDFDocument.load(pdfData);
            return pdfDoc.getPageCount();
        } catch (error) {
            console.error('Error counting PDF pages:', error);
            throw new Error('Failed to count PDF pages');
        }
    }

    /**
     * Get the page count from a web file (File uploaded into browser)
     * @param file - Web file (Blob)
     * @returns Promise with the number of pages
     */
    public async getPageCountFromWebFile(file: File): Promise<number> {
        const fileData = await file.arrayBuffer();
        return this.getPageCount(new Uint8Array(fileData));
    }
}

export const clientPdfDocumentService = ClientPdfDocumentService.getInstance();
